import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import {
  setFilterValue,
  resetFilters,
  searchBlueprintImages
} from "../../reducers/blueprint_images_reducer";
import "select2";
import {
  buildEditableSelect,
  DESKTOP_WIDTH,
  IPAD_WIDTH,
  parseCategoryName,
  scrollToTopPage,
  titleize,
  parseLanguage,
  parseLabelLanguage,
  parseLabelType, isDefined, addHtmlElementClass, removeHtmlElementClass, toBoolean
} from "../../utils/utils";
import I18n from 'i18n.js.erb'


function FilterBlueprintImages(props) {

  const dispatch = useDispatch();
  const searchEnabled = useSelector(state => state.searchEnabled)
  const environment = useSelector(state => state.environment)
  const [hidden, setHidden] = useState(toBoolean(window.localStorage.getItem('hiddenSubmissionListFilterPanel')))
  const [filterPannelIsOpen, setFilterPannelIsOpen] = useState(true);
  const [isActiveFilter, setIsActiveFilter] = useState(false);
  const [focus, setFocus] = useState(false)
  const [displayPokedexNumber, setDisplayPokedexNumber] = useState(true)
  const { sort_by, sorting_direction } = useSelector(state => state.filters)
  const initialFilters = useSelector(state => state.initialFilters)
  const sortingOptions = useSelector(state => state.sortingOptions)
  const sortingDirections = useSelector(state => state.sortingDirections)

  const {
    games, brands, categories, eras, expansions, release_years, release_months, copyrights,
    languages, rarities, versions, editions, illustrators, pokedex_numbers,
    all_label_languages, all_encasings
  } = useSelector(state => state.availableOptionsForSelect)
  const {
    id, name, code, game_id, brand_id, category_id, era_id, released_at, release_year, release_month, release_day, copyright,
    illustrator, expansion_id, collector_number, pokedex_number, language_filter, rarity, version, edition, state,
    encasing, requested_service, label_type, label_language, has_scan, acquired,
    encasing_id, serial_number, image_hashes, submission_list_item_id, created_by, items_type
  } = useSelector(state => state.filters)

  const initialHashes = useSelector(state => state.initialFilters?.image_hashes)
  const isSuperadminUser = useSelector(state => state.isSuperadminUser)

  const handleChangeFilterValue = (e) => {
    dispatch(setFilterValue(e.target.id, e.target.value));
  }

  const handleResetFilters = () => {
    $('.select2-custom').val('').trigger('change.select2');
    setIsActiveFilter(false)
    dispatch(resetFilters(props.perPage))
    if (environment === 'advanced_search') {
      scrollToTopPage()
    }
    if (window.innerWidth <= IPAD_WIDTH && environment === 'advanced_search')
      setFilterPannelIsOpen(false)
    setDisplayPokedexNumber(true)
  }

  const handleSearchCards = () => {
    setIsActiveFilter(true)
    if (environment === 'advanced_search') {
      scrollToTopPage()
    }
    dispatch(searchBlueprintImages(props.perPage))
    if (window.innerWidth <= IPAD_WIDTH && environment === 'advanced_search')
      setFilterPannelIsOpen(false)
  }

  useEffect(() => {
    buildEditableSelect(handleChangeFilterValue, true)
  }, []);

  useEffect(() => {
    if (!isDefined(hidden)) {
      setHidden(false);
    }
    setTimeout(() => {
      if (hidden) {
        removeHtmlElementClass(document, 'submission_list_container_submission', 'pl-16perc');
      } else {
        addHtmlElementClass(document, 'submission_list_container_submission', 'pl-16perc');
      }
    }, 50)
    window.localStorage.setItem('hiddenSubmissionListFilterPanel', hidden)
  }, [hidden])


  useEffect(() => {
    if (environment === 'advanced_search') {
      const onKeyDown = (e) => {
        if (e.key === 'Enter' && focus) {
          if (environment === 'advanced_search') {
            scrollToTopPage()
          }
          dispatch(searchBlueprintImages(props.perPage))
          if (window.innerWidth <= IPAD_WIDTH)
            setFilterPannelIsOpen(false)
        }
      }

      document.addEventListener('keydown', onKeyDown);

      return () => {
        document.removeEventListener('keydown', onKeyDown);
      }
    }
  }, [environment, focus]);

  const showFilters = function () {
    setFilterPannelIsOpen(true)
    if (window.innerWidth < DESKTOP_WIDTH || filterPannelIsOpen) {
      scrollToTopPage()
    }
  }

  useEffect(() => {
    if (games && game_id) {
      for (const game of games)
        if (game_id == game[1] && game[0].indexOf('Pokémon') > -1) {
          setDisplayPokedexNumber(true)
          return
        }
      dispatch(setFilterValue('pokedex_number', ''))
      setDisplayPokedexNumber(false)
    } else {
      setDisplayPokedexNumber(true)
    }
  }, [games, game_id]);


  useEffect(() => {
    if (expansion_id)
      setTimeout(() => { $("span.select2-selection.select2-selection--single[aria-labelledby=select2-expansion_id-container]").addClass("border-aiG-blue-imp"); }, 50)
    else
      $(".select2-selection.select2-selection--single").removeClass("border-aiG-blue-imp");

    if (illustrator)
      setTimeout(() => { $("span.select2-selection.select2-selection--single[aria-labelledby=select2-illustrator-container]").addClass("border-aiG-blue-imp"); }, 50)
    else
      $(".select2-selection.select2-selection--single").removeClass("border-aiG-blue-imp");

    if (rarity)
      setTimeout(() => { $("span.select2-selection.select2-selection--single[aria-labelledby=select2-rarity-container]").addClass("border-aiG-blue-imp"); }, 50)
    else
      $(".select2-selection.select2-selection--single").removeClass("border-aiG-blue-imp");

    if (language_filter)
      setTimeout(() => { $("span.select2-selection.select2-selection--single[aria-labelledby=select2-language_filter-container]").addClass("border-aiG-blue-imp"); }, 50)
    else
      $(".select2-selection.select2-selection--single").removeClass("border-aiG-blue-imp");

    if (version)
      setTimeout(() => { $("span.select2-selection.select2-selection--single[aria-labelledby=select2-version-container]").addClass("border-aiG-blue-imp"); }, 50)
    else
      $(".select2-selection.select2-selection--single").removeClass("border-aiG-blue-imp");

    if (pokedex_number)
      setTimeout(() => { $("span.select2-selection.select2-selection--single[aria-labelledby=select2-pokedex_number-container]").addClass("border-aiG-blue-imp"); }, 50)
    else
      $(".select2-selection.select2-selection--single").removeClass("border-aiG-blue-imp");
  }, [expansion_id, illustrator, rarity, version, language_filter, pokedex_number]);



  const setScroll = function () {
    const zoomIsActive = screen.width > window.innerWidth;
    const zoomValue = (window.outerWidth - 8) / window.innerWidth;
    if (zoomIsActive) {
      $('#advanced-search-filter-box').addClass('advanced-search-pannel-height');

      if (zoomValue < 1.2) {
        $('#advanced-search-filter-box').css('height', '700px');
      }
      if (zoomValue >= 1.2 && zoomValue <= 1.4) {
        $('#advanced-search-filter-box').css('height', '400px');
      }
      if (zoomValue > 1.4 && zoomValue <= 1.7) {
        $('#advanced-search-filter-box').css('height', '350px');
      }
      if (zoomValue > 1.7) {
        $('#advanced-search-filter-box').css('height', '200px');
      }
    } else {
      $('#advanced-search-filter-box').removeClass('advanced-search-pannel-height');
      $('#advanced-search-filter-box').css('height', 'auto');
    }
  }

  $(document).ready(function () {
    setScroll()
  })

  $(window).resize(function () {
    setScroll()
  })


  return (
    <React.Fragment>
      {
        environment !== 'advanced_search' ?
          <div id="blueprint_images_filters_container"
            className={`${environment === 'submission_lists' ? 'submission-list-filters-container submission-lists-filter-container-position' : 'grading-filters-container'} shadow bg-light card pb-5 ${(environment === 'submission_lists' && hidden) ? 'hide-filters-container' : ''}`}>
            {games ? <React.Fragment>
              <div className={`${environment === 'submission_lists' ? 'row align-items-center' : ''}`}>
                <div className={`d-block ${environment === 'submission_lists' ? 'col-11 pr-0' : ''}`}>
                  <div className="form-group d-flex justify-content-end mr-3 mb-2">
                    <button className="btn btn-primary ml-4" onClick={handleResetFilters}>
                      <i className="fas fa-filter" aria-hidden="true" /> Reset
                    </button>
                    <button className="btn btn-success ml-4" disabled={!searchEnabled}
                      onClick={handleSearchCards}>
                      <i className="fas fa-search" aria-hidden="true" /> Search
                    </button>
                  </div>

                  <div className="form-group pt-1">
                    <label className="col-sm-4 control-label pr-0" htmlFor="name">Name:</label>
                    <div className="col-sm-8">
                      <input
                        className={`form-control ${name && isNaN(Number(name)) && name.toString().trim().length < 1 ? 'border-aiG-red-imp' : (name ? 'border-aiG-blue-imp' : '')}`}
                        placeholder="Search by name ..."
                        type="text" name="name" id="name" value={name}
                        onChange={handleChangeFilterValue}>
                      </input>
                    </div>
                  </div>

                  {
                    environment !== 'submission_lists' &&
                    <div className="form-group pt-5">
                      <label className="col-sm-4 control-label pr-0" htmlFor="collector_number">Card Num.:</label>
                      <div className="col-sm-8">
                        <input className={`form-control ${collector_number ? 'border-aiG-blue-imp' : ''}`}
                          placeholder="Card Number"
                          autoFocus={true}
                          type="text" name="collector_number" id="collector_number" value={collector_number}
                          onChange={handleChangeFilterValue}>
                        </input>
                      </div>
                    </div>
                  }

                  <div className="form-group pt-5">
                    <label className="col-sm-4 control-label pr-0" htmlFor="game_id">Game:</label>
                    <div className="col-sm-8">
                      <select className={`form-control ${game_id ? 'border-aiG-blue-imp' : ''}`}
                        name="game_id" id="game_id" value={game_id}
                        onChange={handleChangeFilterValue}>
                        {
                          isDefined(initialFilters.image_hashes) && environment !== 'submission_lists' &&
                          <option value="">Select Game</option>
                        }
                        {games.map(game => {
                          return <option value={game[1]} key={game[1]}>{game[0]}</option>
                        })}
                      </select>
                    </div>
                  </div>

                  <div className="form-group pt-5">
                    <label className="col-sm-4 control-label pr-0" htmlFor="category_id">Category:</label>
                    <div className="col-sm-8">
                      <select className={`form-control ${category_id ? 'border-aiG-blue-imp' : ''}`}
                        name="category_id" id="category_id" value={category_id}
                        onChange={handleChangeFilterValue}>
                        {categories.map(category => {
                          return <option value={category[1]} key={category[1]}>
                            {parseCategoryName(category[0])}
                          </option>
                        })}
                      </select>
                    </div>
                  </div>

                  {
                    environment !== 'submission_lists' ?
                      <React.Fragment>
                        <div className="form-group pt-5">
                          <label className="col-sm-4 control-label pr-0" htmlFor="expansion_id">Expansion:</label>
                          <div className="col-sm-8 d-flex">
                            <select className="form-control select2-custom" name="expansion_id" id="expansion_id"
                              value={expansion_id}
                              onChange={(e) => {
                              }}>
                              <option value="">Select Expansion</option>
                              {expansions.map(expansion => {
                                return <option value={expansion.id} key={expansion.id} label={expansion.icon}>
                                  {expansion.name}
                                </option>
                              })}
                            </select>
                          </div>
                        </div>

                        {
                          eras && eras.length > 0 &&
                          <React.Fragment>
                            <div className="form-group pt-5">
                              <label className="col-sm-4 control-label pr-0" htmlFor="era_id">Era:</label>
                              <div className="col-sm-8 d-flex">
                                <select className={`form-control ${era_id ? 'border-aiG-blue-imp' : ''}`}
                                  name="era_id" id="era_id" value={era_id}
                                  onChange={handleChangeFilterValue}>
                                  <option value="">Select Era</option>
                                  {eras.map(era => {
                                    return <option value={era.id} key={era.id}>{era.name}</option>
                                  })}
                                </select>
                              </div>
                            </div>
                          </React.Fragment>
                        }

                        <div className="form-group pt-5">
                          <label className="col-sm-4 control-label pr-0" htmlFor="language">Language:</label>
                          <div className="col-sm-8 d-flex">
                            <select className="form-control select2-custom"
                              name="language_filter" id="language_filter" value={language_filter}
                              onChange={(e) => {
                              }}>
                              <option value="">Select Language</option>
                              {languages.map(language => {
                                return <option value={language[1]} key={language[1]}>
                                  {titleize(language[0])}
                                </option>
                              })}
                            </select>
                          </div>
                        </div>

                        <div className="form-group pt-5">
                          <label className="col-sm-4 control-label pr-0" htmlFor="version">Version:</label>
                          <div className="col-sm-8 d-flex">
                            <select className="form-control select2-custom"
                              name="version" id="version" value={version}
                              onChange={(e) => {
                              }}>
                              <option value="">Select Version</option>
                              {versions.map(version => {
                                return <option value={version[1]} key={version[1]}>
                                  {titleize(version[0])}
                                </option>
                              })}
                            </select>
                          </div>
                        </div>

                        <div className="form-group pt-5">
                          <label className="col-sm-4 control-label pr-0" htmlFor="rarity">Rarity:</label>
                          <div className="col-sm-8 d-flex">
                            <select className="form-control select2-custom"
                              name="rarity" id="rarity" value={rarity}
                              onChange={(e) => {
                              }}>
                              <option value="">Select Rarity</option>
                              {rarities.map(rarity => {
                                return <option value={rarity[1]} key={rarity[1]}>
                                  {titleize(rarity[0])}
                                </option>
                              })}
                            </select>
                          </div>
                        </div>

                        <div className="form-group pt-5">
                          <label className="col-sm-4 control-label pr-0" htmlFor="edition">Edition:</label>
                          <div className="col-sm-8 d-flex">
                            <select className={`form-control ${edition ? 'border-aiG-blue-imp' : ''}`}
                              name="edition" id="edition" value={edition}
                              onChange={handleChangeFilterValue}>
                              <option value="">Select Edition</option>
                              {editions.map(edition => {
                                return <option value={edition[1]} key={edition[1]}>
                                  {titleize(edition[0])}
                                </option>
                              })}
                            </select>
                          </div>
                        </div>

                        {/*<div className="form-group pt-5">*/}
                        {/*  <label className="col-sm-4 control-label pr-0" htmlFor="released_at">Release:</label>*/}
                        {/*  <div className="col-sm-8 d-flex justify-content-start">*/}
                        {/*    <select className={`form-control ${release_year ? 'border-aiG-blue-imp' : ''} mr-1`}*/}
                        {/*            name="release_year" id="release_year" value={release_year}*/}
                        {/*            onChange={handleChangeFilterValue}>*/}
                        {/*      <option value="">YYYY</option>*/}
                        {/*      {release_years.map(release_year => {*/}
                        {/*        return <option value={release_year[1]} key={release_year[1]}>{release_year[0]}</option>*/}
                        {/*      })}*/}
                        {/*    </select>*/}
                        {/*    <select className={`form-control ${release_month ? 'border-aiG-blue-imp' : ''} mr-1`}*/}
                        {/*            name="release_month" id="release_month" value={release_month}*/}
                        {/*            onChange={handleChangeFilterValue} disabled={release_year === ""}>*/}
                        {/*      <option value="">MM</option>*/}
                        {/*      {release_months.map(release_month => {*/}
                        {/*        return <option value={release_month[1]} key={release_month[1]}>{release_month[0]}</option>*/}
                        {/*      })}*/}
                        {/*    </select>*/}
                        {/*    <select className={`form-control ${release_day ? 'border-aiG-blue-imp' : ''}`}*/}
                        {/*            name="release_day" id="release_day" value={release_day}*/}
                        {/*            onChange={handleChangeFilterValue} disabled={release_year === "" || release_month === ""}>*/}
                        {/*      <option value="">DD</option>*/}
                        {/*      {['01', '02', '03', '04', '05', '06', '07', '08', '09', '10',*/}
                        {/*        '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',*/}
                        {/*        '21', '22', '23', '24', '25', '26', '27', '28', '29'].concat(release_month === '02' ? [] :*/}
                        {/*        (release_month === '11' || release_month === '04' || release_month === '06' || release_month === '09' ? ['30'] : ['30', '31'])).map(release_day => {*/}
                        {/*        return <option value={release_day} key={release_day}>{release_day}</option>*/}
                        {/*      })}*/}
                        {/*    </select>*/}
                        {/*  </div>*/}
                        {/*</div>*/}

                        {/*<div className="form-group pt-5">*/}
                        {/*  <label className="col-sm-4 control-label pr-0" htmlFor="copyright">Copyright:</label>*/}
                        {/*  <div className="col-sm-8 d-flex">*/}
                        {/*    <select className={`form-control ${copyright ? 'border-aiG-blue-imp' : ''}`}*/}
                        {/*            name="copyright" id="copyright" value={copyright}*/}
                        {/*            onChange={handleChangeFilterValue}>*/}
                        {/*      <option value="">Select Copyright</option>*/}
                        {/*      {copyrights.map(copyright => {*/}
                        {/*        return <option value={copyright[1]} key={copyright[1]}>*/}
                        {/*          {copyright[0] !== 'none' ? copyright[0] : 'No Year'}*/}
                        {/*        </option>*/}
                        {/*      })}*/}
                        {/*    </select>*/}
                        {/*  </div>*/}
                        {/*</div>*/}

                        {/*{*/}
                        {/*  environment !== 'submission_lists' &&*/}
                        {/*  <div className="form-group pt-5">*/}
                        {/*    <label className="col-sm-4 control-label pr-0" htmlFor="illustrator">Illustrator:</label>*/}
                        {/*    <div className="col-sm-8">*/}
                        {/*      <select className="form-control select2-custom" name="illustrator" id="illustrator"*/}
                        {/*              value={illustrator}*/}
                        {/*              onChange={(e) => {*/}
                        {/*              }}>*/}
                        {/*        <option value="">Select Illustrator</option>*/}
                        {/*        {illustrators.map(illustrator => {*/}
                        {/*          return <option value={illustrator[1]} key={illustrator[1]}>*/}
                        {/*            {illustrator[0]}*/}
                        {/*          </option>*/}
                        {/*        })}*/}
                        {/*      </select>*/}
                        {/*    </div>*/}
                        {/*  </div>*/}
                        {/*}*/}

                        <div className="form-group pt-5 pb-5">
                          <label className="col-sm-4 control-label pr-0" htmlFor="encasing_id">Antiscratch Code:</label>
                          <div className="col-sm-8">
                            <select className={`form-control ${encasing_id ? 'border-aiG-blue-imp' : ''}`}
                              name="encasing_id" id="encasing_id" value={encasing_id}
                              onChange={handleChangeFilterValue}>
                              <option value="">Select Your Choice</option>
                              {all_encasings.map(encasing => {
                                return <option value={encasing[1]} key={'encasing_' + encasing[1]}>
                                  {encasing[0]}
                                </option>
                              })}
                            </select>
                          </div>
                        </div>
                      </React.Fragment>
                      :
                      <React.Fragment>
                        <div className="form-group pt-5">
                          <label className="col-sm-4 control-label pr-0" htmlFor="brand_id">Brand:</label>
                          <div className="col-sm-8">
                            <select className={`form-control ${brand_id ? 'border-aiG-blue-imp' : ''}`}
                              name="brand_id" id="brand_id" value={brand_id}
                              onChange={handleChangeFilterValue}>
                              {brands.map(brand => {
                                return <option value={brand[1]} key={brand[1]}>{brand[0]}</option>
                              })}
                            </select>
                          </div>
                        </div>

                        <div className="form-group pt-5">
                          <label className="col-sm-4 control-label pr-0" htmlFor="state">State:</label>
                          <div className="col-sm-8">
                            <select className={`form-control ${state ? 'border-aiG-blue-imp' : ''}`}
                              name="state" id="state" value={state}
                              onChange={handleChangeFilterValue}>
                              <option value="">Select Product state</option>
                              {['not_graded_yet', 'already_graded', 'label_not_printed_yet', 'label_to_print', 'printed', 'images_acquired', 'rfid_acquired', 'completed', 'missing_images', 'missing_rfid', 'rejected', 'not_received', 'fake', 'poor', 'not_gradable', 'not_paid', 'mismatched'].map(choice => {
                                return <option value={choice} key={choice}>
                                  {choice === 'printed' ? 'Label printed' : titleize(choice).replaceAll('_', ' ')}
                                </option>
                              })}
                            </select>
                          </div>
                        </div>

                        <div className="form-group pt-5">
                          <label className="col-sm-4 control-label pr-0" htmlFor="created_by">Added By:</label>
                          <div className="col-sm-8">
                            <select className={`form-control ${created_by ? 'border-aiG-blue-imp' : ''}`}
                              name="created_by" id="created_by" value={created_by}
                              onChange={handleChangeFilterValue}>
                              <option value="">Select Creator</option>
                              {['user', 'middleman', 'grader'].map(creator => {
                                return <option value={creator} key={creator}>
                                  {titleize(creator)}
                                </option>
                              })}
                            </select>
                          </div>
                        </div>

                        <div className="form-group pt-5">
                          <label className="col-sm-4 control-label pr-0" htmlFor="encasing">Encasing:</label>
                          <div className="col-sm-8">
                            <select className={`form-control ${encasing ? 'border-aiG-blue-imp' : ''}`}
                              name="encasing" id="encasing" value={encasing}
                              onChange={handleChangeFilterValue}>
                              <option value="">Select Encasing</option>
                              {['sleeve', 'case'].map(encasing => {
                                return <option value={encasing} key={encasing}>
                                  {encasing.toUpperCase()}
                                </option>
                              })}
                            </select>
                          </div>
                        </div>

                        <div className="form-group pt-5">
                          <label className="col-sm-4 control-label pr-0" htmlFor="requested_service">Service:</label>
                          <div className="col-sm-8">
                            <select className={`form-control ${requested_service ? 'border-aiG-blue-imp' : ''}`}
                              name="requested_service" id="requested_service" value={requested_service}
                              onChange={handleChangeFilterValue}>
                              <option value="">Select Service</option>
                              {['grading', 'authentication', 'authentication_with_subgrades'].map(requested_service => {
                                return <option value={requested_service} key={requested_service}>
                                  {requested_service.toUpperCase().replaceAll('_', ' ')}
                                </option>
                              })}
                            </select>
                          </div>
                        </div>

                        <div className="form-group pt-5">
                          <label className="col-sm-4 control-label pr-0" htmlFor="label_type">Label Type:</label>
                          <div className="col-sm-8">
                            <select className={`form-control ${label_type ? 'border-aiG-blue-imp' : ''}`}
                              name="label_type" id="label_type" value={label_type}
                              onChange={handleChangeFilterValue}>
                              <option value="">Select Label Type</option>
                              {['radiant', 'legacy'].map(label_type => {
                                return <option value={label_type} key={label_type}>
                                  {parseLabelType(label_type)}
                                </option>
                              })}
                            </select>
                          </div>
                        </div>

                        <div className="form-group pt-5">
                          <label className="col-sm-4 control-label pr-0" htmlFor="label_language">Label Lan.:</label>
                          <div className="col-sm-8">
                            <select className={`form-control ${label_language ? 'border-aiG-blue-imp' : ''}`}
                              name="label_language" id="label_language" value={label_language}
                              onChange={handleChangeFilterValue}>
                              <option value="">Select Label Lan.</option>
                              {all_label_languages.map(label_language => {
                                return <option value={label_language} key={label_language}>
                                  {label_language !== 'native' ? label_language.toUpperCase() : parseLabelLanguage(label_language)}
                                </option>
                              })}
                            </select>
                          </div>
                        </div>

                        <div className="form-group pt-5">
                          <label className="col-sm-4 control-label pr-0" htmlFor="serial_number">Serial N°:</label>
                          <div className="col-sm-8">
                            <input className={`form-control ${serial_number ? 'border-aiG-blue-imp' : ''}`}
                              placeholder="Serial Number"
                              type="text" name="serial_number" id="serial_number" value={serial_number}
                              onChange={handleChangeFilterValue}>
                            </input>
                          </div>
                        </div>

                        <div className="form-group pt-5 pb-5">
                          <label className="col-sm-4 control-label pr-0" htmlFor="submission_list_item_id">Product
                            Id:</label>
                          <div className="col-sm-8">
                            <input className={`form-control ${submission_list_item_id ? 'border-aiG-blue-imp' : ''}`}
                              placeholder="Product ID"
                              type="number" name="submission_list_item_id" id="submission_list_item_id"
                              value={submission_list_item_id}
                              onChange={handleChangeFilterValue}>
                            </input>
                          </div>
                        </div>

                        <div className="form-group pb-5">
                          <label className="col-sm-4 control-label pr-0" htmlFor="items_type">Items Type:</label>
                          <div className="col-sm-8">
                            <select className={`form-control ${items_type ? 'border-aiG-blue-imp' : ''}`}
                              name="items_type" id="items_type" value={items_type}
                              onChange={handleChangeFilterValue}>
                              <option value="">Select Your Choice</option>
                              {[['Only Supplementary Items', 'supplementary_items'],
                              ['Already converted products', 'submission_list_items'],
                              ['Only Products that comes from a previous supplementary item', 'comes_from_supplementary_item'],
                              ['Only Products that comes from a previous mismatched item', 'comes_from_mismatched_item'],
                              ['Only Extra Products', 'extra_items'],
                              ['Only Products not paid yet', 'not_paid_items'],
                              ['Only Products with extra info printed on label', 'items_with_extra_info']].map(item_type => {
                                return <option value={item_type[1]} key={item_type[1]}>
                                  {item_type[0]}
                                </option>
                              })}
                            </select>
                          </div>
                        </div>
                      </React.Fragment>
                  }

                  {
                    isSuperadminUser && environment !== 'submission_lists' &&
                    <React.Fragment>
                      <div className="form-group pb-5">
                        <label className="col-sm-4 control-label" htmlFor="has_scan">Has Scan:</label>
                        <div className="col-sm-8">
                          <select className={`form-control ${has_scan ? 'border-aiG-blue-imp' : ''}`} name="has_scan"
                            id="has_scan" value={has_scan}
                            onChange={handleChangeFilterValue}>
                            <option value="">Select Your Choice</option>
                            {[['YES', true], ['NO', false]].concat(environment !== 'submission_lists' ? [['Temporary', 'tmp']] : []).map(has_scan => {
                              return <option value={has_scan[1]} key={has_scan[1]}>
                                {has_scan[0]}
                              </option>
                            })}
                          </select>
                        </div>
                      </div>

                      <div className="form-group pb-5">
                        <label className="col-sm-4 control-label" htmlFor="acquired">Acquired:</label>
                        <div className="col-sm-8">
                          <select className={`form-control ${acquired ? 'border-aiG-blue-imp' : ''}`} name="acquired"
                            id="acquired" value={acquired}
                            onChange={handleChangeFilterValue}>
                            <option value="">Select Your Choice</option>
                            {[['YES', true], ['NO', false]].map(acquired => {
                              return <option value={acquired[1]} key={acquired[1]}>
                                {acquired[0]}
                              </option>
                            })}
                          </select>
                        </div>
                      </div>

                      {
                        isSuperadminUser &&
                        <React.Fragment>
                          <div className="form-group pb-5">
                            <label className="col-sm-4 control-label pr-0" htmlFor="id">ID:</label>
                            <div className="col-sm-8">
                              <input className={`form-control ${id ? 'border-aiG-blue-imp' : ''}`}
                                type="number" name="id" id="id" value={id} placeholder="Type ID"
                                onChange={handleChangeFilterValue}>
                              </input>
                            </div>
                          </div>

                          <div className="form-group pb-5">
                            <label className="col-sm-4 control-label pr-0" htmlFor="code">Code:</label>
                            <div className="col-sm-8">
                              <input className={`form-control ${code ? 'border-aiG-blue-imp' : ''}`}
                                type="text" name="code" id="code" value={code} placeholder="Type Code"
                                onChange={handleChangeFilterValue}>
                              </input>
                            </div>
                          </div>
                        </React.Fragment>
                      }
                    </React.Fragment>
                  }

                  {
                    isDefined(initialHashes) &&
                    <div className="form-group pb-5">
                      <label className="col-sm-4 control-label" htmlFor="acquired">Image similarity:</label>
                      <div className="col-sm-8">
                        <select className={`form-control ${image_hashes ? 'border-aiG-blue-imp' : ''}`} name="image_hashes"
                          id="image_hashes" value={image_hashes}
                          onChange={handleChangeFilterValue}>
                          {[['YES', initialHashes], ['NO', '']].map(choice => {
                            return <option value={choice[1]} key={choice[1]}>
                              {choice[0]}
                            </option>
                          })}
                        </select>
                      </div>
                    </div>
                  }
                </div>
                {environment === 'submission_lists' &&
                  <div className="col-1 p-0 cursor-pointer" onClick={() => setHidden(!hidden)}>
                    <img src={window.location.origin + `/images/icons/black/arrow-${hidden ? 'right' : 'left'}.svg`}></img>
                  </div>
                }
              </div>
            </React.Fragment> : "Loading"}
          </div>
          :

          <div
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            className="overflow-auto">
            <div
              className={` ${isActiveFilter && 'icon--bg-active'} rounded-right show-on-mobile expansion__filter--mobile-position`}>
              <button type="button" className="btn p-7px"
                onClick={() => showFilters()}>
                <i
                  className={` ${isActiveFilter ? 'icon--color-active' : 'icon-color-standard'} fas fa-filter enable-filters-expansions-icon`} />
              </button>
            </div>


            <div className="advanced-search-filters-position">
              {
                environment === 'advanced_search' &&
                <div className="row pl-3 pr-3">
                  <div className="col-12 pl-4 mt-10px mb-10px text-center text-lg-left">
                    <h2 className="text-weight-700 mb-0">{I18n.t('js.advancedSearch.filterComponent.title')}</h2>
                  </div>
                </div>
              }

              {games !== undefined ? <React.Fragment>
                <div className={`bg-white card pt-3 ${!filterPannelIsOpen && 'd-none'}`}>

                  <div className="row show-on-mobile">
                    <div className="col-12 text-right">
                      <button type="button" className="btn p-0 mr-10px text--size-title"
                        onClick={(e) => setFilterPannelIsOpen(false)}>
                        <i className="fas fa-times show-on-mobile" />
                      </button>
                    </div>
                  </div>


                  <div id="advanced-search-filter-box">


                    <div className="row">
                      <div className="col-6">
                        <label className="col-12 pr-0" htmlFor="name">{I18n.t('js.filters.name')}:</label>
                        <div className="col-12 pr-0">
                          <input className={`form-control ${name && isNaN(Number(name)) && name.toString().trim().length < 1 ? 'border-aiG-red-imp' : (name ? 'border-aiG-blue-imp' : '')}`}
                            placeholder={I18n.t('js.filters.placeholder.cardName')}
                            type="text" name="name" id="name" value={name}
                            onChange={handleChangeFilterValue}>
                          </input>
                        </div>
                      </div>

                      <div className="col-6 pl-0">
                        <label className="col-12 pl-0"
                          htmlFor="game_id">{I18n.t('js.advancedSearch.filterComponent.game')}:</label>
                        <div className="col-12 pl-0">
                          <select className={`form-control ${game_id ? 'border-aiG-blue-imp' : ''}`}
                            name="game_id" id="game_id" value={game_id}
                            onChange={handleChangeFilterValue}>
                            {games.map(game => {
                              return <option value={game[1]} key={game[1]}>{game[0]}</option>
                            })}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-10px">
                      <div className="col-6">
                        <label className="col-12 control-label"
                          htmlFor="category_id">{I18n.t('js.filters.sort.category')}:</label>
                        <div className="col-12 pr-0">
                          <select className={`form-control ${category_id ? 'border-aiG-blue-imp' : ''}`}
                            name="category_id" id="category_id" value={category_id}
                            onChange={handleChangeFilterValue}>
                            {categories.map(category => {
                              return <option value={category[1]} key={category[1]}>
                                {parseCategoryName(category[0])}
                              </option>
                            })}
                          </select>
                        </div>
                      </div>


                      {
                        eras && eras.length > 0 &&
                        <div className="col-6 pl-0">
                          <label className="col-12 pl-0 control-label"
                            htmlFor="era_id">{I18n.t('js.filters.sort.era')}:</label>
                          <div className="col-12 pl-0 d-flex">
                            <select className={`form-control ${era_id ? 'border-aiG-blue-imp' : ''}`}
                              name="era_id" id="era_id" value={era_id}
                              onChange={handleChangeFilterValue}>
                              <option value="">{I18n.t('js.advancedSearch.filterComponent.eraPlaceholder')}</option>
                              {eras.map(era => {
                                return <option value={era.id} key={era.id}>{era.name}</option>
                              })}
                            </select>
                          </div>
                        </div>
                      }
                    </div>

                    <div className="row mt-10px">
                      <div className="col-6">
                        <label className="col-12 pr-0 control-label"
                          htmlFor="expansion_id">{I18n.t('js.advancedSearch.filterComponent.expansions')}:</label>
                        <div className="col-12 pr-0">
                          <select className="form-control select2-custom"
                            name="expansion_id" id="expansion_id"
                            value={expansion_id}
                            onChange={() => {
                            }}
                          >
                            <option value="">{I18n.t('js.advancedSearch.filterComponent.expansionsPlaceholder')}</option>
                            {expansions.map(expansion => {
                              return <option value={expansion.id} key={expansion.id} label={expansion.icon}>
                                {expansion.name}
                              </option>
                            })}
                          </select>
                        </div>
                      </div>

                      <div className="col-6 pl-0">
                        <label className="col-12 pl-0"
                          htmlFor="collector_number">{I18n.t('js.advancedSearch.filterComponent.cardNumber')}:</label>
                        <div className="col-12 pl-0">
                          <input className={`form-control ${collector_number ? 'border-aiG-blue-imp' : ''}`}
                            placeholder={I18n.t('js.advancedSearch.filterComponent.cardNumberPlaceholder')}
                            type="text" name="collector_number" id="collector_number" value={collector_number}
                            onChange={handleChangeFilterValue}>
                          </input>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-10px">
                      <div className="col-6">
                        <label className="col-12 pr-0 control-label"
                          htmlFor="copyright">{I18n.t('js.advancedSearch.filterComponent.copyright')}:</label>
                        <div className="col-12 pr-0 d-flex">
                          <select className={`form-control ${copyright ? 'border-aiG-blue-imp' : ''}`}
                            name="copyright" id="copyright" value={copyright}
                            onChange={handleChangeFilterValue}>
                            <option value="">{I18n.t('js.advancedSearch.filterComponent.copyrightPlaceholder')}</option>
                            {copyrights.map(copyright => {
                              return <option value={copyright[1]} key={copyright[1]}>
                                {copyright[0] !== 'none' ? copyright[0] : I18n.t('js.advancedSearch.filterComponent.noYear')}
                              </option>
                            })}
                          </select>
                        </div>
                      </div>

                      {
                        displayPokedexNumber &&
                        <div className="col-6 pl-0">
                          <label className="col-12 pl-0 control-label"
                            htmlFor="pokedex_number">{I18n.t('js.advancedSearch.filterComponent.pokedexNumber')}:</label>
                          <div className="col-12 pl-0 d-flex">
                            <select className="form-control select2-custom"
                              name="pokedex_number" id="pokedex_number"
                              value={pokedex_number}
                              onChange={() => {
                              }}
                            >
                              <option
                                value="">{I18n.t('js.advancedSearch.filterComponent.pokedexNumberPlaceholder')}</option>
                              {pokedex_numbers.map(pokedex_number => {
                                return <option value={pokedex_number[1]} key={pokedex_number[1]}>
                                  {pokedex_number[0]}
                                </option>
                              })}
                            </select>
                          </div>
                        </div>
                      }
                    </div>

                    <div className="row mt-10px">
                      <div className="col-6">
                        <label className="col-12 pr-0 control-label"
                          htmlFor="language">{I18n.t('js.advancedSearch.filterComponent.language')}:</label>
                        <div className="col-12 pr-0 d-flex">
                          <select className="form-control select2-custom"
                            name="language_filter" id="language_filter" value={language_filter}
                            onChange={() => { }}>
                            <option value="">{I18n.t('js.advancedSearch.filterComponent.languagePlaceholder')}</option>
                            {languages.map(language => {
                              return <option value={language[1]} key={language[1]}>
                                {parseLanguage(language[0])}
                              </option>
                            })}
                          </select>
                        </div>
                      </div>

                      <div className="col-6 pl-0">
                        <label className="col-12 pl-0 control-label"
                          htmlFor="rarity">{I18n.t('js.advancedSearch.filterComponent.rarity')}:</label>
                        <div className="col-12 pl-0 d-flex">
                          <select className="form-control select2-custom"
                            name="rarity" id="rarity" value={rarity}
                            onChange={() => { }}>
                            <option value="">{I18n.t('js.advancedSearch.filterComponent.rarityPlaceholder')}</option>
                            {rarities.map(rarity => {
                              return <option value={rarity[1]} key={rarity[1]}>
                                {titleize(rarity[0])}
                              </option>
                            })}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-10px">
                      <div className="col-6">
                        <label className="col-12 pr-0 control-label"
                          htmlFor="version">{I18n.t('js.advancedSearch.filterComponent.version')}:</label>
                        <div className="col-12 pr-0 d-flex">
                          <select className="form-control select2-custom"
                            name="version" id="version" value={version}
                            onChange={() => { }}>
                            <option value="">{I18n.t('js.advancedSearch.filterComponent.versionPlaceholder')}</option>
                            {versions.map(version => {
                              return <option value={version[1]} key={version[1]}>
                                {titleize(version[0])}
                              </option>
                            })}
                          </select>
                        </div>
                      </div>

                      <div className="col-6 pl-0">
                        <label className="col-12 pl-0 control-label"
                          htmlFor="edition">{I18n.t('js.advancedSearch.filterComponent.edition')}:</label>
                        <div className="col-12 pl-0 d-flex">
                          <select className={`form-control ${edition ? 'border-aiG-blue-imp' : ''}`}
                            name="edition" id="edition" value={edition}
                            onChange={handleChangeFilterValue}>
                            <option value="">{I18n.t('js.advancedSearch.filterComponent.editionPlaceholder')}</option>
                            {editions.map(edition => {
                              return <option value={edition[1]} key={edition[1]}>
                                {titleize(edition[0])}
                              </option>
                            })}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-10px">
                      <div className="col-6">
                        <label className="col-12 pr-0 control-label"
                          htmlFor="illustrator">{I18n.t('js.advancedSearch.filterComponent.illustrator')}:</label>
                        <div className="col-12 pr-0">
                          <select className="form-control select2-custom"
                            name="illustrator" id="illustrator"
                            value={illustrator}
                            onChange={() => {
                            }}
                          >
                            <option
                              value="">{I18n.t('js.advancedSearch.filterComponent.illustratorPlaceholder')}</option>
                            {illustrators.map(illustrator => {
                              return <option value={illustrator[1]} key={illustrator[1]}>
                                {illustrator[0]}
                              </option>
                            })}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-10px">
                      <div className="col-12">
                        <label className="col-12 control-label"
                          htmlFor="released_at">{I18n.t('js.advancedSearch.filterComponent.releaseDate')}</label>
                        <div className="col-12 d-flex justify-content-start">
                          <select className={`form-control ${release_year ? 'border-aiG-blue-imp' : ''} mr-1`}
                            name="release_year" id="release_year" value={release_year}
                            onChange={handleChangeFilterValue}>
                            <option
                              value="">{I18n.t('js.advancedSearch.filterComponent.releaseDateYPlaceholder')}</option>
                            {release_years.map(release_year => {
                              return <option value={release_year[1]} key={release_year[1]}>{release_year[0]}</option>
                            })}
                          </select>
                          <select className={`form-control ${release_month ? 'border-aiG-blue-imp' : ''} mr-1`}
                            name="release_month" id="release_month"
                            value={release_month}
                            onChange={handleChangeFilterValue} disabled={release_year === ""}>
                            <option
                              value="">{I18n.t('js.advancedSearch.filterComponent.releaseDateMPlaceholder')}</option>
                            {release_months.map(release_month => {
                              return <option value={release_month[1]} key={release_month[1]}>{release_month[0]}</option>
                            })}
                          </select>
                          <select className={`form-control ${release_day ? 'border-aiG-blue-imp' : ''}`}
                            name="release_day" id="release_day" value={release_day}
                            onChange={handleChangeFilterValue}
                            disabled={release_year === "" || release_month === ""}>
                            <option
                              value="">{I18n.t('js.advancedSearch.filterComponent.releaseDateDPlaceholder')}</option>
                            {['01', '02', '03', '04', '05', '06', '07', '08', '09', '10',
                              '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
                              '21', '22', '23', '24', '25', '26', '27', '28', '29'].concat(release_month === '02' ? [] :
                                (release_month === '11' || release_month === '04' || release_month === '06' || release_month === '09' ? ['30'] : ['30', '31'])).map(release_day => {
                                  return <option value={release_day} key={release_day}>{release_day}</option>
                                })}
                          </select>
                        </div>
                      </div>
                      <div className="col-6 pl-0">
                      </div>
                    </div>

                    <div className="row mt-10px">
                      <div className="col-12">
                        {sortingOptions !== undefined &&
                          <div className="row">

                            <label className="col-3 ml-3">{I18n.t('js.advancedSearch.filterComponent.sortBy')}</label>
                            <div className=" col-8 pl-0 pr-0 form-group d-flex justify-content-md-end align-items-center">

                              <div className="ml-3">
                                <select className={`form-control ${sort_by ? 'border-aiG-blue-imp' : ''}`}
                                  name="sort_by" id="sort_by" value={sort_by}
                                  onChange={handleChangeFilterValue}>
                                  {sortingOptions.map(option => {
                                    return <option value={option.value} key={option.value}>{I18n.t(option.locale)}</option>
                                  })}
                                </select>
                              </div>
                              <div className="ml-2"><b>:</b></div>
                              <div className="ml-2 mr-2px">
                                <select className={`form-control ${sorting_direction ? 'border-aiG-blue-imp' : ''}`}
                                  name="sorting_direction" id="sorting_direction"
                                  value={sorting_direction}
                                  onChange={handleChangeFilterValue}>
                                  {sortingDirections.map(direction => {
                                    return <option value={direction.value}
                                      key={direction.value}>{I18n.t(direction.locale)}</option>
                                  })}
                                </select>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>


                    <div className="d-flex justify-content-end mb-3 row">
                      <div className="col-4">
                        <button
                          className="btn-standard-outline pr-2 pl-2 pt-6px-imp btn-inside-table br-20px"
                          onClick={handleResetFilters}>{I18n.t('js.advancedSearch.filterComponent.resetFilter')}</button>
                      </div>

                      <div className="col-6 mr-3">
                        <button
                          className="btn-standard bg-aig-gradient text-light pr-2 pl-2 btn-standard-resized pt-6px-imp h-auto btn-inside-table br-20px"
                          disabled={!searchEnabled}
                          onClick={handleSearchCards}>{I18n.t('js.advancedSearch.filterComponent.search')}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </React.Fragment> : "Loading"}
            </div>
          </div>
      }
    </React.Fragment>

  );
}


export default FilterBlueprintImages